import clsx from "clsx";
import React from "react";
import { useHistory } from "react-router-dom";

import Preloader from "~/components/Preloader";
import { useDealerData } from "~/app/Context/DealerContext";
import { useDataMain } from "~/entity/Dealer";
import { usePermissions } from "~/shared/context/PermissionContext";

import BlockAboutDealer from "./BlockAboutDealer";
import BlockAfterSales from "./BlockAfterSales";
import BlockDealerShip from "./BlockDealerShip";
import BlockManagement from "./BlockManagement";
import BlockNewVehicle from "./BlockNewVehicle";
import BlockProfitability from "./BlockProfitability";
import BlockQ from "./BlockQ";
import BlockQuality from "./BlockQuality";
import BlockQualityNet from "./BlockQualityNet/Index";
import BlockRnBank from "./BlockRnBank";
import BlockStaffInfo from "./BlockStaffInfo";

import s from "./styles.less";

const MainPage = () => {
  const history = useHistory();
  const goToQ = () => {
    history.replace("/q/");
  };
  const { hasPermission } = usePermissions();
  const { DealerId } = useDealerData();

  const { getDataDealerMain, getMainDataById } = useDataMain({ id: DealerId });

  if (!DealerId) return <Preloader />;

  return (
    <div className={s.wrap}>
      <div className={clsx([s.line, s.line1])}>
        {!getDataDealerMain?.isLoading && getDataDealerMain?.data ? (
          <>
            <BlockAboutDealer
              data={getDataDealerMain.data?.dealer}
              loading={getDataDealerMain.isLoading}
            />
            <BlockManagement
              data={getDataDealerMain.data?.manager}
              loading={getDataDealerMain.isLoading}
            />
          </>
        ) : (
          <Preloader />
        )}
      </div>

      <div className={clsx([s.line, s.line2])}>
        <BlockDealerShip
          isDoc={hasPermission("dealergraph.projectDocumentation.get")}
          isArea={true}
        />
        <BlockQ oldVisual onClick={goToQ} />
        <BlockRnBank />
      </div>

      <div className={clsx([s.line, s.line3])}>
        <BlockNewVehicle />
        <BlockAfterSales />
      </div>

      <div className={clsx([s.line, s.line4])}>
        <BlockQuality
          isLoading={getMainDataById.isLoading}
          data={getMainDataById.data?.quality}
          refetch={getMainDataById.refetch}
          error={getMainDataById.isError}
        />
        <BlockQualityNet />
        <BlockProfitability />
        <BlockStaffInfo
          isLoading={getMainDataById?.isLoading}
          data={getMainDataById.data?.employee}
          error={getMainDataById.isError}
        />
      </div>
    </div>
  );
};

export default MainPage;
